import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'highlight'})
export class HighlightPipe implements PipeTransform {
  transform(value: string, term?: string): string {
    if (!term?.length || !value) {
      return value;
    }
    const escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${escaped})`, 'gi');
    return value.replace(regex, '<mark>$1</mark>');
  }
}
